<!-- 新增维护站（分步向导：电站信息 → 设备列表） -->
<template>
  <div class="app-container">
    <div
      v-loading="optionsLoading"
      class="app-content terminal-dialog add-wizard"
      style="margin-top: 0px !important;"
      element-loading-text="选项加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="wizard-wrap">
        <!-- 左侧步骤导航 -->
        <aside class="side-nav">
          <ul class="side-nav-list">
            <li
              v-for="(step, index) in wizardSteps"
              :key="index"
              class="side-nav-item"
              :class="[active === index ? 'is-active' : '', active > index ? 'is-done' : '']"
            >
              <span class="nav-dot">
                <i v-if="active > index" class="el-icon-check" />
                <b v-else>{{ index + 1 }}</b>
              </span>
              <span class="nav-text">{{ step }}</span>
            </li>
          </ul>
        </aside>

        <!-- 右侧表单 -->
        <div class="wizard-content">
          <el-scrollbar style="height:100%">
            <!-- 第一步 电站信息 -->
            <div v-if="active === 0" key="1" class="step-pane">
              <el-form ref="addStationFormRef" class="add-station-form" label-width="180px" :model="formModel" :rules="formRules">
                <!-- 电站图片 -->
                <el-form-item label="电站图片">
                  <img-upload ref="imgRef" v-model="formModel.img" />
                  <span style="color: var(--primary-color);">仅支持jpg、jpeg、png格式</span>
                </el-form-item>

                <!-- 电站类型 -->
                <el-form-item v-if="!isJinXiangHuaShengUser" label="电站类型" prop="orgtype">
                  <el-select v-model="formModel.orgtype" clearable placeholder="请选择电站类型" @change="orgtypeChange">
                    <el-option v-for="item in orgtypeOptions" :key="item.value" :label="$t(item.label)" :value="item.value" />
                  </el-select>
                </el-form-item>

                <!-- 电站名称 -->
                <el-form-item label="电站名称" prop="orgname">
                  <el-input v-model="formModel.orgname" clearable />
                </el-form-item>

                <!-- 电站所属省份 -->
                <el-form-item label="所属省份" prop="province">
                  <el-select v-model="formModel.province" clearable filterable placeholder="请选择所属省份">
                    <el-option v-for="item in provinceOptions" :key="item.value" :label="item.key" :value="item.value" />
                  </el-select>
                </el-form-item>

                <!-- 时区 -->
                <el-form-item label="所属时区" prop="tzonecode">
                  <el-select v-model="formModel.tzonecode" clearable filterable placeholder="请选择所属时区">
                    <el-option v-for="(item, index) in timezoneOptions" :key="index" :label="item.key" :value="item.value" />
                  </el-select>
                </el-form-item>

                <!-- 装机容量 -->
                <el-form-item v-if="formModel.orgtype !== '2' && formModel.orgtype !== '4'" label="装机容量【单位:kWp】" prop="capacity">
                  <el-input-number v-model="formModel.capacity" :min="1" :step="0.1" controls-position="right" :precision="2" style="margin-top: 0;" />
                </el-form-item>

                <div class="btn-area">
                  <el-button type="primary" @click="handleNext">下一步</el-button>
                </div>
              </el-form>
            </div>

            <!-- 第二步 设备列表 -->
            <div v-else key="2" class="step-pane">
              <div class="collector-title">
                <i class="el-icon-connection" />
                <span class="ct-title">设备列表</span>
                <span class="ct-sub">输入本电站采集器的SN号，可连续添加多个</span>
                <span class="ct-count">已添加 {{ deviceCount }} 台</span>
              </div>
              <div class="collector-panel">
                <div class="collector-input-row">
                  <el-input v-model="deviceInput" placeholder="请输入采集器SN号" clearable @keyup.enter.native="addDevice" />
                  <el-button type="primary" @click="addDevice">添加</el-button>
                </div>
                <div v-if="formDeviceList.length" class="collector-list">
                  <span v-for="(sn, index) in formDeviceList" :key="sn" class="collector-chip">
                    <i class="el-icon-connection chip-icon" />
                    <span class="chip-text">{{ sn }}</span>
                    <i class="el-icon-close chip-close" @click="removeDevice(index)" />
                  </span>
                </div>
                <div v-else class="collector-empty">
                  <i class="el-icon-information" />
                  <span>尚未添加采集器，请至少添加一个SN号</span>
                </div>
              </div>
              <div class="btn-area">
                <el-button @click="active = 0">上一步</el-button>
                <el-button type="primary" :loading="submitLoading" @click="handleAddStation">提交</el-button>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImgUpload from '@views/Imgupload'
import { GetAddresses, GetTimeZones } from '@apis/Universal.js'
import { CreateStationByTerminal } from '@apis/Stations.js'

const stationImagePath = `${process.env.VUE_APP_BASE_API}/imgs/stations`
export default {
  components: {
    ImgUpload,
  },
  data () {
    return {
      /** 向导当前步骤 */
      active: 0,
      /** 采集器SN输入框 */
      deviceInput: '',
      /** 采集器SN列表 */
      formDeviceList: [],
      /** 时区选项 */
      timezoneOptions: [],
      /** 省份选项 */
      provinceOptions: [],
      /** 电站类型选项 */
      orgtypeOptions: [
        { label: 'text.zc', value: '0' },
        { label: 'text.cn', value: '1' },
        { label: 'text.qx', value: '2' },
        { label: 'text.db', value: '3' },
        { label: 'text.orgtype_switch', value: '4' }
      ],
      /** 选项加载中 */
      optionsLoading: false,
      /** 新增维护站表单提交中 */
      submitLoading: false,
      /** 新增维护站表单数据 */
      formModel: {
        img: `${stationImagePath}/default.png`,
        orgtype: '',
        orgname: '',
        province: '',
        tzonecode: '101',
        capacity: 1
      },
      /** 新增维护站表单验证规则 */
      formRules: {
        orgtype: [{ required: true, message: '请选择电站类型', trigger: 'change' }],
        province: [{ required: true, message: '请选择电站所属省份', trigger: 'change' }],
        orgname: [{ required: true, message: '请输入电站名称', trigger: 'blur' }],
        tzonecode: [{ required: true, message: '请选择时区', trigger: 'change' }],
      },
    }
  },
  computed: {
    /** 向导步骤标题 */
    wizardSteps: function () {
      return ['电站信息', '设备列表']
    },
    /** 已添加设备数量 */
    deviceCount: function () {
      return this.formDeviceList.length
    },
    /** * 登录账号是否是金象华升账号 */
    isJinXiangHuaShengUser: function () {
      return this.$store.getters.id === process.env.VUE_APP_JinXiangHuaSheng_Userid
    }
  },
  created () {
    this.formModel.orgtype = this.isJinXiangHuaShengUser ? '2' : ''
  },
  mounted () {
    this.getTimeZoneAndProvinceOptions()
  },
  methods: {

    /** 获取时区和省份选项 */
    getTimeZoneAndProvinceOptions () {
      this.optionsLoading = true
      Promise.all([GetTimeZones({ id: '' }), GetAddresses({ id: '44' })]).then(res => {
        this.timezoneOptions = res[0].data
        this.provinceOptions = res[1].data
        this.optionsLoading = false
      }).catch(() => {
        this.optionsLoading = false
        this.$message({
          message: '获取选项失败',
          type: 'error'
        })
      })
    },

    /** 电站类型切换后，清空已添加的采集器列表 */
    orgtypeChange () {
      this.formDeviceList = []
    },

    /** 添加采集器SN */
    addDevice () {
      const sn = (this.deviceInput || '').trim()
      if (!sn) {
        this.$msgError('请输入采集器SN号')
        return
      }
      if (this.formDeviceList.includes(sn)) {
        this.$msgError('请不要重复输入SN号')
        return
      }
      this.formDeviceList.push(sn)
      this.deviceInput = ''
    },

    /** 移除采集器SN */
    removeDevice (index) {
      this.formDeviceList.splice(index, 1)
    },

    /** 设备列表校验（必填） */
    validateDeviceList () {
      if (!Array.isArray(this.formDeviceList) || this.formDeviceList.length === 0) {
        this.$msgError('请至少添加一个采集器SN号')
        return false
      }
      return true
    },

    /** 第一步：校验电站信息后进入设备列表 */
    handleNext () {
      this.$refs.addStationFormRef.validate((validResult) => {
        if (validResult) {
          this.active = 1
        }
      })
    },

    /** 新增维护站 */
    handleAddStation () {
      if (!this.validateDeviceList()) {
        return
      }
      const postData = {
        image: this.formModel.img,
        stationType: this.formModel.orgtype,
        stationName: this.formModel.orgname,
        stationProvinceCode: this.formModel.province,
        stationTimezoneCode: this.formModel.tzonecode,
        installedCapacity: this.formModel.capacity,
        gatewaySnList: this.formDeviceList
      }
      if (postData.image.indexOf('base64') === -1) {
        postData.image = null
      }
      this.submitLoading = true
      CreateStationByTerminal(postData).then(res => {
        this.submitLoading = false
        this.$confirm('电站添加成功,是否返回电站列表?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success'
        }).then(() => {
          this.$router.replace({
            path: 'list'
          })
        })
      }).catch(() => {
        this.submitLoading = false
        this.$message({
          message: '电站添加失败',
          type: 'error'
        })
      })
    }
  }
}
</script>
<style>
@import './components/createterminal.css';

/* 向导页面级微调（复用创建终端弹窗的深色向导样式） */
.add-wizard {
  border-radius: 10px;
  overflow: hidden;
}
.add-wizard .wizard-wrap {
  background: #15213f;
}
.add-wizard .step-pane {
  width: auto;
  max-width: 780px;
  margin: 14px auto 0;
  padding: 0 16px 10px 0;
}
.add-wizard .add-station-form {
  max-width: 640px;
}
/* 第二步设备列表标题行 */
.add-wizard .collector-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  color: #cdd8f0;
  font-size: 15px;
}
.add-wizard .collector-title > i {
  color: #6cb3ff;
  font-size: 16px;
}
.add-wizard .collector-title .ct-title {
  font-weight: 600;
}
.add-wizard .collector-title .ct-sub {
  color: #8494b8;
  font-size: 12px;
}
.add-wizard .collector-title .ct-count {
  margin-left: auto;
  padding: 2px 12px;
  border: 1px solid rgba(64, 158, 255, 0.4);
  border-radius: 20px;
  background: rgba(64, 158, 255, 0.16);
  color: #6cb3ff;
  font-size: 12px;
}
</style>
